import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import {
  AERIAL_TRAM_MODE,
  BICYCLE_MODE,
  BICYCLE_RENT_MODE,
  BUS_MODE,
  BUS_FX_MODE,
  CAR_HAIL_MODE,
  CAR_MODE,
  CAR_RENT_MODE,
  LIGHT_RAIL_MODE,
  MICROMOBILITY_MODE,
  MICROMOBILITY_RENT_MODE,
  PARATRANSIT_MODE,
  PARK_AND_RIDE_MODE,
  STREETCAR_MODE,
  SUBWAY_MODE,
  RAIL_MODE,
} from '#/shared/constants';

// these components are complex SVGs so they are lazy loaded with
// loadable-components to reduce the size of the initial bundle
const AerialTram = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/AerialTram')
);
const Bike = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Bike')
);
const Bus = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Bus')
);
const BusFX = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/BusFX')
);
const Car = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Car')
);
const Lift = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Lift')
);
const Max = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Max')
);
const Scooter = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Scooter')
);
const Streetcar = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Streetcar')
);
const Wes = loadable(() =>
  import('../GeneratedIcons/trimet/full-color-vehicles/Wes')
);

export const vehicleIconLookup = {
  [AERIAL_TRAM_MODE]: AerialTram,
  [BICYCLE_MODE]: Bike,
  [BICYCLE_RENT_MODE]: Bike,
  [BUS_MODE]: Bus,
  [BUS_FX_MODE]: BusFX,
  [CAR_HAIL_MODE]: Car,
  [CAR_MODE]: Car,
  [CAR_RENT_MODE]: Car,
  [PARATRANSIT_MODE]: Lift,
  [LIGHT_RAIL_MODE]: Max,
  [MICROMOBILITY_MODE]: Scooter,
  [MICROMOBILITY_RENT_MODE]: Scooter,
  [PARK_AND_RIDE_MODE]: Car,
  [RAIL_MODE]: Wes,
  [STREETCAR_MODE]: Streetcar,
  [SUBWAY_MODE]: Max,
};

function VehicleIcon({ mode, ...svgProps }) {
  const Icon = vehicleIconLookup[mode && mode.toUpperCase()];

  // prop spreading allows all SVG props to be forwarded to the icon component
  // eslint-disable-next-line react/jsx-props-no-spreading
  return Icon ? <Icon data-testid="vehicle-icon" {...svgProps} /> : null;
}

VehicleIcon.propTypes = {
  /**
   * Transportation mode ID used to determine which icon is returned by this
   * component, maps to OTP transit mode strings with some custom additions
   */
  mode: PropTypes.string.isRequired,
};

export default VehicleIcon;
